import { Navigate, Outlet } from "react-router-dom";

import { useIsLawyer } from "@/shared/hooks/useIsLawyer";
import { LAWYER_ROUTES } from "@/shared/constants/paths";

/**
 * Wrapper for family routes (invitations, sharing).
 * Redirects confirmed lawyers to their dashboard. Always renders children
 * while loading to prevent auth-triggered remounts from resetting flow state.
 */
export function FamilyRouteWrapper() {
  const { isLawyer, isLoading } = useIsLawyer();

  if (isLawyer && !isLoading) {
    return <Navigate to={LAWYER_ROUTES.DASHBOARD} replace />;
  }

  return <Outlet />;
}
